import moment from 'moment';

export const standardDateStamp = (date) => moment(date).format('MM/DD/YY');

export default {
  apiFormat(data, fields) {
    _.forEach(fields, (field) => {
      if (typeof data[field] === 'object') {
        data[field] = moment(data[field]).format('YYYY-MM-DD');
      } else if (
        typeof data[field] === 'string' &&
        data[field].indexOf('/') > -1
      ) {
        data[field] = moment(data[field], 'YYYY/MM/DD', true).format(
          'YYYY-MM-DD'
        );
      }
    });

    return data;
  },

  datepickerFormat(data, fields) {
    // have to format these dates like this to deal with datepicker not using moment.
    // other datepickers didn't work worth a darn and I don't have time to fork and fix this datepicker
    _.forEach(fields, (field) => {
      data[field] = moment(data[field], 'YYYY-MM-DD', true).format(
        'YYYY/MM/DD'
      );
    });

    return data;
  },
};
